import React from 'react';
import { useIntl } from 'react-intl';

import { store } from 'config/store/configureStore';
import Button from 'ui/base/Button';
import useNotification from 'ui/base/Notification';

/**
 * @type {React.FC<{
 *    intl: import('react-intl').IntlShape,
 *    title: import('react-intl').MessageDescriptor,
 *    onClick: (store: Object) => void,
 *  } & import('antd/lib/button').ButtonProps>}
 */
const CustomButton = ({ onClick, title: titleMsgDescriptor = { id: 'refresh', defaultMessage: 'Refresh' }, ...buttonProps }) => {
  const intl = useIntl();
  const notification = useNotification();
  const title = intl.formatMessage(titleMsgDescriptor);

  const handleOnClick = () => {
    notification.destroy();
    onClick(store);
  };

  return (
    <Button onClick={handleOnClick} {...buttonProps}>
      {title}
    </Button>
  );
};

export default CustomButton;
